module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2022/img/hubspot-tools-logo.png"